export default __webpack_public_path__ + "static/media/Box.2ea80961.glb";